import React from 'react';
import Document from 'components/Document';

//import parseHash from 'components/Auth/parseHash';
import useAuth from 'components/Auth/useAuth';
import useSharedDialog from 'components/SharedDialog/useSharedDialog';

import ConfirmButton from './components/ConfirmButton';
import DenyButton from './components/DenyButton';
import DocumentHistoryButton from './components/DocumentHistoryButton';
import DownloadButton from './components/DownloadButton';
import StatusButton from './components/StatusButton';
import WarningButton from './components/WarningButton';

import { useSnackbar } from 'notistack';

import useClient from 'components/Auth/useClient';
import PaperVoid from './components/PaperVoid';
import PaperExpired from './components/PaperExpired';
import PaperForbidden from './components/PaperForbidden';

export default function DocumentViewer(props)
{
  // page data
  const [data, setData] = React.useState(undefined);
  const [buttons, setButtons] = React.useState([]);
  const [reload, setReload] = React.useState(0);
  const [resend, setResend] = React.useState(false);
  const [voidFlag, setVoidFlag] = React.useState(false);
  const [expiredFlag, setExpiredFlag] = React.useState(false);
  const [forbiddenFlag, setForbiddenFlag] = React.useState(false);

  const auth = useAuth();
  const client = useClient();
  const { enqueueSnackbar } = useSnackbar();

  // download content by id
  const id = props.match && props.match.params && props.match.params.id;
  React.useEffect(() => {
    if (!auth.isValid) return;
    if (auth.expired()) {
      setExpiredFlag(true);
    }
    else if (id) {
      client.get(`api/document/${id}${props.location.search}`)
        .then(response => {
          setData(response.data);
          setExpiredFlag(false);
          setVoidFlag(false);
          setForbiddenFlag(false);
        })
        .catch(error => {
          if (error.response.status == 409) {
            setVoidFlag(true);
          }
          else {
            setForbiddenFlag(true);
          }
          enqueueSnackbar('閲覧権限の無いドキュメントです。', { whiteSpace: 'pre-line', variant: 'error' });
        });
    }
  }, [id, props.location.search, auth, reload]);

  React.useEffect(() => {
    if (!resend) return;
    const resendDialog = sharedDialog("resend");
    resendDialog.open();
  }, [resend]);

  const handleReload = React.useCallback(() => {
    setReload(reload+1);
  }, [reload, setReload]);

  const handleDocumentHistory = React.useCallback(() => {
    const documentHistoryDialog = sharedDialog("documentHistory");
    documentHistoryDialog.open({ histories : data.histories });
  }, [data]);

  const sharedDialog = useSharedDialog();

  const handleConfirm = React.useCallback(() => {
    const confirmDialog = sharedDialog("confirm");
    confirmDialog.open({ id, contentId : data.contentId, handleReload, name: data.confirm.name, buttonName: data.confirm.buttonName, title : data.confirm.title, message : data.confirm.message });
  }, [sharedDialog, id, data]);

  const handleDeny = React.useCallback(() => {
    const denyDialog = sharedDialog("deny");
    denyDialog.open({ id, contentId : data.contentId, handleReload, name: data.confirm.name });
  }, [sharedDialog, id, data]);

  const handleWarning = React.useCallback(() => 
    props.history.push(`${props.location.pathname}`), [props.location]);

  const handleDownload = React.useCallback(() => {
    if (!data) {
      return;
    }
    const downloadDialog = sharedDialog("download");
    downloadDialog.open({id, contentId: data.contentId, title:data.name, download: `${data.fileName}.pdf`});
  }, [data, sharedDialog]);

  /*
  const handleHistoryMail = React.useCallback(() => {
    const historyDialog = sharedDialog("historyMail");
    historyDialog.open({id});
  }, [sharedDialog]);
  */
  /*
  const history = useHistory();
  const handleReceiveDocument = React.useCallback(() => {
    history.push("/search");
  }, [history]);
  */

  // setup button by jwt user specification
  React.useEffect(() => {
    const temp = [];
    if (data) {
      if (data.warning) {
        temp.push(WarningButton({ ...data.warning, onClick:handleWarning }));
      }

      // 承認・承諾ボタン
      if (data.confirm) {
        if (data.confirmed) {
          // 承認済みの場合は否認可能か確認
          if (data.confirm.canDeny)
          {
            temp.push(DenyButton({ name:data.confirm.status, onClick: handleDeny }));
          }
          else {
            temp.push(StatusButton({ name:data.confirm.name, confirmed: data.confirmed }));
          }
        }
        else {
          // 未承認の場合は承認可能か確認
          if (data.confirm.canConfirm)
          {
            temp.push(ConfirmButton({ name:data.confirm.buttonName, onClick: handleConfirm }));
          }
          else
          {
            temp.push(StatusButton({ name:data.confirm.name, confirmed: data.confirmed }));
          }
        }
      }

      // PDFのダウンロードボタン
      if (data.published) {
        temp.push(DownloadButton({ onClick: handleDownload }));
      }

      if (data.histories && data.histories.length > 0) {
        temp.push(DocumentHistoryButton({ onClick: handleDocumentHistory }));
      }
 
      if (data.alert) {
        const alertDialog = sharedDialog("alert");
        alertDialog.open({ ...data.alert });
      }
    }

    // ログイン済みユーザーの場合受信一覧を表示
    /*
    if (auth.isUser) {
      temp.push(ReceiveDocumentButton({ onClick: handleReceiveDocument }));
    }
    */

    setButtons(temp);
  }, [data, auth]);

  if (voidFlag) return <PaperVoid />;
  if (forbiddenFlag) return <PaperForbidden />;
  if (expiredFlag) return <PaperExpired />;

  return (<Document data={data}
    appBarButtons={buttons}
      {...props} />);
}